<template>
  <div :id="md5" class="vlc">
    <p style="display: none">{{ videoSrc }}</p>
    <div v-if="isSupportVLC && isEndCheck" class="vlc-container" style="width: 100%; height: 100%">
      <div :class="['vlc-container-instance', options.toolbar ? 'has-toolbar' : '']">
        <object
          id="vlc"
          classid="clsid:9BE31822-FDAD-461B-AD51-BE1D1C159921"
          style="width: 100%; height: 100%; position: relative; top: 0; left: 0"
          events="True"
        >
          <param name="ShowDisplay" value="True" />
          <param name="AutoLoop" value="False" />
          <param name="AutoPlay" value="False" />
          <param name="Volume" value="50" />
          <param name="Toolbar" value="false" />
          <param name="StartTime" value="0" />
          <embed
            pluginspage="http://www.videolan.org"
            type="application/x-vlc-plugin"
            width="100%"
            height="100%"
            toolbar="false"
            branding="true"
            text="Waiting for video"
            bgcolor="#000000"
            allowfullscreen="true"
            name="vlc"
          />
        </object>
      </div>
      <div class="vp-toolbar" v-if="options.toolbar">
        <button class="vp-vlc-button" type="button" title="Fullscreen" aria-disabled="false" @click="openFullscreen">
          <span class="fullscreen" aria-hidden="true"></span>
        </button>
      </div>
    </div>
    <template v-else-if="isEndCheck">
      <div class="wrap-tip">
        <div class="wrap-content">
          <div class="wrap-xiazai"><i class="iconfont icon-xiazai3"></i></div>
          <div style="margin-bottom: 10px">
            <div style='text-align: center;line-height: 24px;'>
                <div style='color:white'>{{'您当前未安装播放器插件'}}</div>
                <div>
                   <a target="__blank" href="https://get.videolan.org/vlc/3.0.18/win32/vlc-3.0.18-win32.exe" download="" class="clickDwn">点此下载安装</a>
                </div>
              <!-- <a target="__blank" href="https://get.videolan.org/vlc/3.0.16/win32/vlc-3.0.18-win32.exe" download="" class="clickDwn">点击下载</a> -->
              <!-- <span style="font-size: 14px">监控播放插件</span> -->
            </div>
          </div>
          <!-- <div class="wrap-xiazai" style="color: #999; font-size: 12px">请使用360极速或安全浏览器的急速模式查看</div> -->
        </div>
      </div>
    </template>
  </div>
</template>
<script>
// import axios from 'axios'
import axios from './axios'
import { formatDate } from './../utils/index'
import { hex_md5, str_hmac_md5 } from './../utils/md5'
import { CALLBACK_ENUM, makeMessage } from '../utils/enum'
import { compress, encodePCM, reSampleAndEncodeAudioData, aLawEncode, encodeAudioData, encodePCMA } from './../utils/encode'

// 获取 VLC js 队形
const getVLC = (name, md5) => {
  let hexMD = md5 ? md5 : ''
  const vlcContainer = window.document.getElementById(hexMD)
  // 只寻找vlc节点下方的embed
  if (vlcContainer) {
    let vlcDoms = vlcContainer.getElementsByTagName('embed')
    let vlc = vlcDoms.namedItem(name)
    if (vlc) {
      return vlc
    }
    return null
  }

  // 如果找不到对应容器内的VLC，返回null而不是尝试全局查找
  return null
}

const doGo = (mrl, name, md5, vlcOptions) => {
  return new Promise((resolve, reject) => {
    var vlc = getVLC(name, md5)
    if (vlc && vlc.playlist) {
      vlc.playlist.items.clear()
      // https://wiki.videolan.org/VLC_command-line_help/
      var options = [':rtsp-tcp']
      var itemId = vlc.playlist.add(mrl, 'fancy name', options)
      if (itemId != -1) {
        // play MRL
        vlc.playlist.playItem(itemId)
        if (vlcOptions && vlcOptions.aspectRatio) {
          vlc.video.aspectRatio = vlcOptions.aspectRatio
        }
        if (vlcOptions && vlcOptions.muted) {
          vlc.audio.toggleMute()
        }
      } else {
        console.error('无法播放当前视频')
        // 使用console.error代替alert，避免弹窗干扰用户
        // alert('cannot play at the moment !')
      }
      resolve()
    } else {
      console.error('找不到VLC对象，容器ID:', md5)
      reject('找不到VLC对象！')
    }
  })
}

const checkVLCPlugin = (name, md5) => {
  let isSupportVlc = false
  // 360安全查询mimeTypes=0 兼容
  if (navigator.mimeTypes.length === 0) {
    isSupportVlc = true
  }
  for (let index = 0; index < navigator.mimeTypes.length; index++) {
    const item = navigator.mimeTypes[index]
    if (item.type === 'application/x-vlc-plugin') {
      isSupportVlc = true
    }
  }

  return isSupportVlc

  // return new Promise((resolve, reject) => {
  // 	setTimeout(() => {
  // 		var vlc = getVLC(name, md5);
  //     // 注意 此处无法通过判断VLC携带属性来判断vlc版本 以后也不添加了
  //     if (vlc) {
  //       console.log("您的浏览器VLC版本为！", vlc.VersionInfo);
  //       resolve(true);
  //     } else {
  // 			console.error("您的浏览器不支持VLC Plugin！");
  // 			resolve(false);
  // 		}
  // 	}, 1000)
  // })
}

export default {
  name: 'VLC',
  props: {
    src: String,
    options: {
      type: Object,
      default: () => {
        return {
          toolbar: false
        }
      }
    }
  },
  data() {
    return {
      isFullscreen: false,
      isSupportVLC: true,
      isEndCheck: false,
      videoSrc: null,
      playSrcFlag: false, //用于防止多次调用play
      md5: 'vlc',
      isCover: false,
      uniqueId: 'vlc_' + Date.now() + '_' + Math.floor(Math.random() * 1000), // 添加唯一ID
      // 语音对讲
      audioContext: null,
      processorNode: null,
      audioSourceNode: null,
      mediaStream: null,
      dataList: [],
      websocket: null,
      wsConnected: false
    }
  },
  computed: {
    ratio: function () {
      // 不太可能出现这种情况，常见的音频设备采样率是 48k 44.1k
      if (!this.audioContext || this.audioContext.sampleRate < 8000) {
        return 1
      }
      return Math.floor(this.audioContext.sampleRate / 8000)
    }
  },
  watch: {
    'options.aspectRatio': {
      handler(newVal, oldVal) {
        if (newVal) {
          let vlc = getVLC('vlc', this.md5)
          if (vlc && vlc.video) {
            vlc.video.aspectRatio = newVal
          }
        }
      },
      immediate: true
    },
    src(newVal, oldVal) {
      this.playSrcFlag = false
      this.init()
    }
  },
  async mounted() {
    this.audioContext = new AudioContext()
  },
  destroyed() {
    this.playSrcFlag = false
  },
  methods: {
    async init() {
      this.isSupportVLC = checkVLCPlugin('vlcTest', 'vlcTestContainer')
      this.isEndCheck = true

      if (!this.src) {
        console.warn('未接收到视频流！')
        // 即使没有视频流，也使用唯一ID
        this.md5 = this.uniqueId
        return
      }
      // 使用uniqueId作为前缀，确保每个实例都有唯一ID
      this.md5 = this.uniqueId + '_' + hex_md5(this.src)
      console.log('this.md5', this.md5, this.src)
      this.isCover = this.options.cover ? true : false

      if (this.isSupportVLC) {
        this.$nextTick(() => {
          this.playSrc(this.src)
        })
      }
    },
    dispose() {
      return new Promise((resolve, reject) => {
        this.playSrcFlag = false

        setTimeout(
          function () {
            let vlc = getVLC('vlc', this.md5)
            if (vlc && vlc.playlist) {
              // 停止播放
              vlc.playlist.stop()
              // 清空播放列表
              vlc.playlist.items.clear()
            }
            // 标记当前实例已销毁
            this.isEndCheck = false;
            resolve()
          }.bind(this),
          500  // 减少等待时间，提高响应速度
        )
      })
    },
    playSrc(src) {
      // 闭包访问外部变量失效  不使用src参数
      let that = this
      if (this.playSrcFlag) {
        console.log('Play Src Is Activing!')
        return
      }
      setTimeout(() => {
        let vlc = getVLC('vlc', that.md5)
        if (vlc && that.src) {
          console.log('start', that.src)
          doGo(that.src, 'vlc', that.md5, that.options)
            .then((res) => {
              that.playSrcFlag = false
              if (that.isCover) {
                var rect = vlc.getBoundingClientRect()
                const scale = Math.floor(rect.width / rect.height)
                if (vlc && vlc.video) {
                  vlc.video.aspectRatio = `${scale}:1`
                }
              }
            })
            .catch((err) => {
              that.playSrcFlag = false
              console.log('Play Error!', that.src, err)
            })
        }
      }, 1000)
      this.playSrcFlag = true
    },
    // 截图APi
    screenShot() {
      // let vlc = getVLC("vlc", this.md5);
      // if (vlc) {
      //   console.log(vlc)
      //   vlc.video.takeSnapshot();
      // }
    },
    // 列表播放
    playMultVideo(playlist, index, startTime) {
      let vlc = getVLC('vlc', this.md5)
      var items = []
      var options = [':vout-filter=deinterlace', ':deinterlace-mode=linear']
      if (vlc) {
        vlc.playlist.clear()
        playlist.map((item) => {
          let itemId = vlc.playlist.add(item, '', options)
          items.push(itemId)
        })
        //
        let playId = items[index]
        vlc.playlist.playItem(playId)
        // 暂时进行异步 设置播放起始时间
        setTimeout(() => {
          vlc.input.time = startTime * 1000
        }, 1000)
      }
    },
    previewBack(startTime, endTime, videoBackCode) {
      let url = '/api/iot/video/getVideoCallback'

      const startStr = formatDate('yyyymmddhhiiss', startTime)
      const endStr = formatDate('yyyymmddhhiiss', endTime)

      axios
        .get(url, {
          params: {
            code: videoBackCode,
            st: startStr,
            end: endStr
          }
        })
        .then((res) => {
          if (res.data.status === 200) {
            // 先销毁再播放
            doGo(res.data.result, 'vlc', this.md5)
              .then((res) => {})
              .catch((err) => {})
          }
        })
    },
    changeMute() {
      const vlc = getVLC('vlc', this.md5)
      if (vlc) {
        vlc.audio.toggleMute()
      }
    },
    openFullscreen() {
      this.isFullscreen = !this.isFullscreen
      const vlc = getVLC('vlc', this.md5)
      const code = this.$parent.code ? this.$parent.code : ''
      const value = this.isFullscreen ? 1 : 0

      vlc.video.toggleFullscreen()

      this.$parent.$emit('callback', makeMessage(CALLBACK_ENUM.FULL_SCREEN, code, value))
    },
    getMediaStream() {
      // 大部分浏览器有安全限制，http 协议访问的页面 navigator.mediaDevices 也是 undefined， 仅提供 https 服务的可以忽略这个问题
      if (!navigator.mediaDevices) {
        return Promise.reject('您的浏览器不支持获取用户设备，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }
      return navigator.mediaDevices
        .getUserMedia({ audio: { sampleRate: 8000 } })
        .catch(() => Promise.reject('请确保录音设备正常，并允许浏览器获取录音权限，否则无法使用对讲功能'))
    },
    downsampleBuffer(buffer, rate) {
      let audioContext = new AudioContext()
      let sampleRate = audioContext.sampleRate // 当前设备采样频率

      if (rate == sampleRate) {
        return buffer
      }
      if (rate > sampleRate) {
        throw 'downsampling rate show be smaller than original sample rate'
      }
      var sampleRateRatio = sampleRate / rate
      var newLength = Math.round(buffer.length / sampleRateRatio)
      var result = new Float32Array(newLength)
      var offsetResult = 0
      var offsetBuffer = 0
      while (offsetResult < result.length) {
        var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio)
        var accum = 0,
          count = 0
        for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
          accum += buffer[i]
          count++
        }
        result[offsetResult] = accum / count
        offsetResult++

        offsetBuffer = nextOffsetBuffer
      }
      return result
    },
    async makeAudioContextRunning() {
      // 一般不会出现这种情况，以防万一
      if (!this.audioContext || this.audioContext.state === 'closed') {
        this.audioContext = new AudioContext({
          sampleRate: 8000,
          latencyHint: 'interactive'
        })
      }
      if (this.audioContext.state === 'suspended') {
        await this.audioContext.resume()
      }
    },

    async startVoice(webSrc) {
      console.log('start');
      this.websocket = new WebSocket(webSrc)
      this.websocket.onopen = this.onWebSocketOpen
      this.websocket.onclose = this.onWebSocketClose
      this.websocket.onerror = this.onWebSocketError
      this.mediaStream = await this.getMediaStream()

      await this.makeAudioContextRunning()
      try {
        this.audioSourceNode = this.audioContext.createMediaStreamSource(this.mediaStream)

        // console.log(this.audioContext, this.mediaStream, this.audioSourceNode)

        // 只采集单声道方便处理数据
        this.processorNode = this.audioContext.createScriptProcessor(4096, 1, 1)
        this.audioSourceNode.connect(this.processorNode)
        // sampleRate = 8k & bufferSize = 4096 => 每 0.512s 触发一次 onaudioprocess
        this.processorNode.onaudioprocess = this.onAudioProcess

        this.processorNode.connect(this.audioContext.destination)
      } catch (e) {
        throw new Error('您的浏览器音频相关接口异常，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }
    },

    onAudioProcess(event) {
      const lData = event.inputBuffer.getChannelData(0)
      // var l = channelData.length;
      // var buf = new Int16Array(l)

      // while (l--) {
      //     buf[l] = channelData[l]*0xFFFF;    //convert to 16 bit
      // }

      aLawEncode

      encodePCM
      encodePCMA
      encodeAudioData
      // PCMA
      if (this.wsConnected) {
        this.websocket.send(
          encodeAudioData(
            compress(
              {
                left: lData,
                right: []
              },
              48000,
              8000
            )
          )
        )
      }

      return
    },

    sendAudioData(dataList) {
      const base64Audio = reSampleAndEncodeAudioData(dataList, 4096, this.ratio)
      // console.log('base64Audio', base64Audio)
      if (this.wsConnected) {
        this.websocket.send(base64Audio)
      }
      // console.log(base64Audio)
    },
    onWebSocket2Open() {
      this.wsConnected = true
    },
    onWebSocket2Close() {
      this.wsConnected = false
    },
    onWebSocket2Error() {
      this.wsConnected = false
    },
    onWebSocketOpen() {
      this.wsConnected = true
    },
    onWebSocketClose() {
      this.wsConnected = false
    },
    onWebSocketError(e) {
      console.error(e)
      this.wsConnected = false
    },
    stopVoice() {
      console.log('stop')
      if (this.dataList.length) {
        this.sendAudioData(this.dataList)
        this.dataList = []
      }
      this.releaseResources()
    },

    releaseResources() {
      if (this.audioSourceNode) {
        this.audioSourceNode.disconnect()
      }
      if (this.processorNode) {
        this.processorNode.disconnect()
      }
      if (this.mediaStream) {
        this.mediaStream.getAudioTracks().forEach((track) => track.stop())
      }
    }
  }
}
</script>
<style lang="scss">
.vlc {
  z-index: 1;
  width: 100%;
  height: 100%;
  &-container {
    position: relative;
    &-instance {
      width: 100%;
      height: 100%;
      &.has-toolbar {
        width: 100%;
        height: calc(100% - 30px);
      }
    }
  }
  .clickDwn {
    color: #4680ff;
    font-size: 14px;
    text-decoration:none
  }

  .icon-xiazai3 {
    font-size: 44px;
    color: #9999;
  }

  .wrap-tip {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: black;
    .wrap-content {
      .wrap-xiazai {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
